import { FC } from 'react'
import classNames from 'classnames'
import { Text } from 'components/atoms'

type Props = {
  text: string
  label: string
  size?: 24 | 28
}

export const TextWithLabel: FC<Props> = ({ label, text, size = 24 }) => {
  return (
    <div
      className={classNames({
        'w-full flex ': true,
        'min-h-6 rounded-[5px] bg-white custom-border-2px': size === 24,
        'min-h-7 rounded-[7px] bg-black border border-solid border-[#FFAA3B]':
          size === 28,
      })}
    >
      <Text
        text={label}
        className={classNames({
          'flex flex-1 items-center justify-center bg-gradation01 !text-white':
            true,
          'rounded-[6px] !text-base !leading-[20.48px]': size === 28,
          'rounded-[5px] !text-sm !font-bold !leading-[17.92px]': size === 24,
        })}
      />
      <Text
        text={text}
        className={classNames({
          'flex flex-1 items-center justify-center !text-lg !leading-[23.04px]':
            true,
          '!text-white': size === 28,
          '!text-black': size === 24,
        })}
      />
    </div>
  )
}
